// extracted by mini-css-extract-plugin
export default {"cell":"style_cell__XiZ7G","cell_picture":"style_cell_picture__vdkCs","cellTag":"style_cellTag__UjaTE","picture":"style_picture__YVHrf"};